module.exports = __webpack_public_path__ + "static/img/homeLogo.5e5abe9e.png";